import { render, staticRenderFns } from "./RespostaCadastroConfirmacaoTable.vue?vue&type=template&id=d5e9fbc4"
import script from "./RespostaCadastroConfirmacaoTable.vue?vue&type=script&lang=js"
export * from "./RespostaCadastroConfirmacaoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports